import { GameProviderBySlugRequestDto } from '@/services/dto/game-providers/game-provider-by-slug-request.dto';
import { GameProvidersQueryKeys } from '../../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { GameProvider } from '@/models/game/provider';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { fetchGameProviderBySlug } from './service';
import { UseGameProvidersBySlugQueryKey } from './props';

export function useGameProviderBySlug(
  options?: Partial<GameProviderBySlugRequestDto>,
) {
  const { slug } = options ?? {};
  const queryKey: UseGameProvidersBySlugQueryKey = [
    GameProvidersQueryKeys.BySlug,
    {
      slug: slug as string,
    },
  ];

  const { data, error, isPending, refetch, fetchStatus } = useQuery<
    GameProvider,
    AxiosError<GenericError>,
    GameProvider,
    UseGameProvidersBySlugQueryKey
  >({
    queryKey,
    queryFn: fetchGameProviderBySlug,
    enabled: !!slug,
  });

  return {
    isLoading: isPending && fetchStatus !== 'idle',
    gameProvider: data,
    error,
    refetch,
  };
}
